module.exports = __webpack_public_path__ + "img/Impact.0a9bbb2b.svg";